import { Entity, Query } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

@Entity()
export class DummyEntity extends AdornisEntity {
  static override _class = 'DummyEntity';

  @Query(type => Boolean)
  static dummyQuery() {
    return async () => true;
  }
}
